import {
  BodySmall,
  formatDate,
  getFrontendConfigValue,
  LinkButton,
  notEmpty,
  SmallSurveyCard,
  theme,
} from '@arnold/common';
import styled from '@emotion/styled';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getCategoryIcon, isLoggedUserSysAdmin } from '../../lib/helpers';
import { SurveyInfo } from '../SurveysOverview/RowParts';
import { DashboardQuery, ProcessStatus, OrganizationQuery, TopicGroupTypeCode } from '../../generated/hooks';
import { DashboardSection } from './DashboardSection';
import { REPORT_LINK } from '@arnold/core';

type ProcessSurveysProps = {
  organization: NonNullable<OrganizationQuery['organization']>;
  activeProcessSurveys?: NonNullable<DashboardQuery['user']['organization']>['activeProcessSurveys'];
  onResultsClick: () => void;
};

const SurveyInfoSpan = styled.span`
  margin-left: ${theme.spacing.d} !important;
`;

export const ProcessSurveys: FC<ProcessSurveysProps> = ({ organization, activeProcessSurveys, onResultsClick }) => {
  const { t } = useTranslation('dashboard');

  if (!activeProcessSurveys?.length) {
    return null;
  }

  return (
    <DashboardSection title={t('processSurveys')} buttons={<></>} key={'processSurveys'} keyName={'process-surveys'}>
      {activeProcessSurveys.map((surveyGroup) => {
        const commonAccessKey = surveyGroup.topLevelReport?.accessKey;
        return (
          <SmallSurveyCard
            dataIcom={'process-survey-card'}
            key={surveyGroup.id}
            headerIcon={getCategoryIcon(!surveyGroup.topicGroup.categoryCode, surveyGroup.topicGroup.categoryCode)}
            header={surveyGroup.topicGroup.name}
            results={
              <BodySmall>
                {formatDate(surveyGroup.from)}
                <SurveyInfoSpan>
                  <SurveyInfo
                    isSequential={true}
                    notstartedReason={surveyGroup.notstartedReason?.filter(notEmpty)}
                    inLicenceInterval={
                      !surveyGroup.hasOutOfLicenceInterval || surveyGroup.status === ProcessStatus.Archived
                    }
                    organization={organization}
                    status={surveyGroup.status}
                  />
                </SurveyInfoSpan>
              </BodySmall>
            }
            footer={
              <>
                {commonAccessKey && (
                  <LinkButton
                    margin={'0'}
                    onClick={() => {
                      goToSGResults(commonAccessKey);
                      onResultsClick();
                    }}
                  >
                    {t('results')}
                  </LinkButton>
                )}
                <LinkButton
                  href={`/${surveyGroup.topicGroup.typeCode === TopicGroupTypeCode.Exit ? 'exit' : 'processSurvey'}/${
                    surveyGroup.id
                  }`}
                >
                  {t('detail')}
                </LinkButton>
              </>
            }
          />
        );
      })}
    </DashboardSection>
  );
};

const goToSGResults = (reportAccessKey: string) =>
  window.open(
    `${getFrontendConfigValue('ARNOLD_URL')}/${REPORT_LINK.REPORT_SEQUENCE}/${reportAccessKey}${
      isLoggedUserSysAdmin() ? '?sysAdmin' : ''
    }`,
    '_blank',
  );
